
















































import { Vue, Component, State, namespace, Provide } from 'nuxt-property-decorator'
import isEmpty from 'lodash/isEmpty'
import ExperienceSearchFilter from '~/components/experience/search-filter/desktop/search-filter.vue'
import TnaActivityCard from '~/components/tour/tna-activity-card/index.vue'
import { Experience } from '~/types/experience'
import { getInhouseExtDataByTags } from '~/components/experience/section/utils'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component({
  components: {
    TnaActivityCard,
    ExperienceSearchFilter
  }
})

export default class SearchResultActivityList extends Vue {
  @State klook!: Data.Klook
  @experience.Action setUrlQuery!: Function
  @experience.State urlQuery!: UrlQuery
  @experience.State searchResultActivities!: []
  @experience.State useNewCardTemplate!: boolean
  @experience.State resultActivitiesCardRatio!: string
  @experience.State searchResultActivitiesCount!: number
  @experience.State pageType!: string

  pageNumber: number = 1

  @Provide()
  resetPage() {
    this.pageNumber = 1
  }

  onChange(index: number) {
    this.setUrlQuery({
      page: index
    })
  }

  get gtmContent() {
    return this.pageType === 'search'
      ? 'Experience SearchResult|ExperienceSearchResult_Activity_Clicked|'
      : 'Experience Category|ExperienceCategory_Activity_Clicked|'
  }

  get isBot() {
    return this.klook.isBot
  }

  getImageAltByCard(card: any) {
    return card.brand_info?.image_alt ?? ''
  }

  cardSpm(card: any, index: number) {
    const size = this.urlQuery.size || 24
    const idx = (this.pageNumber - 1) * Number(size) + index
    const ext = this.composeExtParam(card)
    return `Activity_LIST?oid=activity_${card.activity_id}&idx=${idx}&len=${this.searchResultActivitiesCount}&ext=${ext}`
  }

  composeExtParam(card: any) {
    const { brand_info = {}, product_tags = {} } = card || {}
    let prop = {}
    if (!isEmpty(brand_info) && brand_info?.tags?.length) {
      prop = {
        campaign_tags: brand_info.tags
      }
    }

    if (!isEmpty(product_tags)) {
      prop = { ...prop, ...product_tags }
    }

    getInhouseExtDataByTags(prop)

    return encodeURIComponent(JSON.stringify(prop))
  }

  paginationHref(page: number, _pagesize: number, _total: number) {
    const { path, query } = this.$route
    const currentQuery = {
      ...query,
      page
    } as any

    let currentPath = `${path}?`
    Object.keys(currentQuery).forEach((key: any, index: number) => {
      if (index > 0) {
        currentPath += '&'
      }
      currentPath += `${key}=${currentQuery[key]}`
    })

    return currentPath
  }

  mounted() {
    this.pageNumber = Number(this.urlQuery.page) || 1
  }
}
